import type { DatasetEditFormProps } from "./dataset-edit-form.type";
import type { DatasetUpdateVariables } from "@/entities/dataset";

import { Button, Divider, Form, Input, Space } from "antd";
import { useTranslation } from "react-i18next";

import { useOnFormClose } from "@/hooks/forms";

const { useForm } = Form;

const DatasetEditForm = ({
  dataset,
  loading,
  onApplyClick,
}: DatasetEditFormProps) => {
  const [form] = useForm();
  const { t } = useTranslation();
  const closeSidePanelForm = useOnFormClose(form);

  const defaultValues = {
    name: dataset.name,
    description: dataset.description,
  };

  const onApplyButtonClick = () => {
    const newDatasetValues: DatasetUpdateVariables = {
      name: form.getFieldValue("name"),
      description: form.getFieldValue("description"),
    };
    onApplyClick?.(newDatasetValues);
    closeSidePanelForm();
  };

  return (
    <>
      <Form form={form} layout="vertical" initialValues={defaultValues}>
        <Form.Item name="name" label={t("dataset:form.name.label")}>
          <Input
            placeholder={t("dataset:form.name.label")}
            data-testid="name"
          />
        </Form.Item>
        <Form.Item
          name="description"
          label={t("dataset:form.description.label")}
        >
          <Input.TextArea
            placeholder={t("dataset:form.description.label")}
            data-testid="description"
          />
        </Form.Item>
      </Form>
      <Divider />
      <Space>
        <Button onClick={closeSidePanelForm}>{t("global:cancel")}</Button>
        <Button
          onClick={onApplyButtonClick}
          loading={loading}
          type="primary"
          data-testid="apply"
        >
          {t("global:apply")}
        </Button>
      </Space>
    </>
  );
};

export default DatasetEditForm;
